<template>
	<section class="DashboardPage LeaveDashboardPage">
		<div class="filters-container">
			<select v-model="selectedWeek" @change="selectedMonth = null; refreshData()">
				<option :value="null" disabled>Week</option>
				<option v-for="week in weeks" :value="week">Week: {{ week }}</option>
			</select>
			<select v-model="selectedMonth" @change="selectedWeek = null; refreshData()">
				<option :value="null" disabled>Maand</option>
				<option v-for="month in months" :value="month.value">{{month.label}}</option>
			</select>
			<select v-model="selectedUser" @change="selectedVan = null; refreshData()">
				<option :value="null" disabled>Medewerker</option>
				<option value="all">Alles</option>
				<option v-for="user in users" :value="user.id">{{user.display_name}}</option>
			</select>
			<select v-model="selectedVan" @change="selectedUser = null; refreshData()">
				<option :value="null" disabled>Ploeg</option>
				<option value="all">Alles</option>
				<option v-for="van in vans" :value="van.id">{{van.display_name}}</option>
				<option value="other">Overig</option>
			</select>
			<select v-model="selectedBranch" @change="refreshUserFilters(); refreshData();">
				<option :value="null" disabled>Vestiging</option>
				<option value="all">Alles</option>
				<option v-for="branch in branches" :value="branch">{{branch}}</option>
			</select>
		</div>

		<div class="card">
			<div class="title">
				<button class="unfold button" @click="showApprovedWorkingHours = !showApprovedWorkingHours">
					<ChevronUpIcon v-if="showApprovedWorkingHours" size="36"/>
					<ChevronDownIcon v-else size="36"/>
				</button>
				<span>GOEDGEKEURDE URENREGISTRATIE</span>
			</div>
			<div class="approved table" v-if="showApprovedWorkingHours">
				<div class="headers row">
					<div class="unfold-placeholder"></div>
					<span>Datum</span>
					<span>Medewerker</span>
					<span>Begintijd</span>
					<span>Eindtijd</span>
					<span>Gewerkt</span>
					<div></div>
				</div>
				<div class="row" v-for="teamWorkingHour in approvedWorkingHours">
					<div class="inner-row clickable" @click="unfoldedApprovedWorkingHoursId = unfoldedApprovedWorkingHoursId === teamWorkingHour.id + teamWorkingHour.date ? null : teamWorkingHour.id + teamWorkingHour.date">
						<button class="unfold button">
							<ChevronUpIcon v-if="unfoldedApprovedWorkingHoursId === teamWorkingHour.id + teamWorkingHour.date" size="36"/>
							<ChevronDownIcon v-else size="36"/>
						</button>
						<span>{{ parseDate(teamWorkingHour.date) }}</span>
						<span>{{ teamWorkingHour.display_name }}</span>
						<span></span>
						<span></span>
						<span>{{ teamWorkingHour.totalTimeWorked }}</span>
						<div></div>
					</div>
					<div class="inner-row" v-if="unfoldedApprovedWorkingHoursId === teamWorkingHour.id + teamWorkingHour.date" v-for="userWorkingHour of teamWorkingHour.working_hours_members">
						<div class="unfold"></div>
						<span>{{ parseDate(userWorkingHour.date)}}</span>
						<span>{{ userWorkingHour.display_name }}</span>
						<span>{{ formatTime(userWorkingHour.working_hour.start_time) }}</span>
						<span>{{ formatTime(userWorkingHour.working_hour.end_time) }}</span>
						<span>{{ userWorkingHour.working_hour.timeWorked }}</span>
						<div>
						</div>
					</div>
				</div>
				<div class="row" v-if="approvedWorkingHoursOther != null">
					<div class="inner-row clickable" @click="unfoldedApprovedWorkingHoursId = unfoldedApprovedWorkingHoursId === approvedWorkingHoursOther.id + approvedWorkingHoursOther.date ? null : approvedWorkingHoursOther.id + approvedWorkingHoursOther.date">
						<button class="unfold button">
							<ChevronUpIcon v-if="unfoldedApprovedWorkingHoursId === approvedWorkingHoursOther.id + approvedWorkingHoursOther.date" size="36"/>
							<ChevronDownIcon v-else size="36"/>
						</button>
						<span>{{ parseDate(approvedWorkingHoursOther.date) }}</span>
						<span>{{ approvedWorkingHoursOther.display_name }}</span>
						<span></span>
						<span></span>
						<span>{{ approvedWorkingHoursOther.totalTimeWorked }}</span>
						<div></div>
					</div>
					<div class="inner-row" v-if="unfoldedApprovedWorkingHoursId === approvedWorkingHoursOther.id + approvedWorkingHoursOther.date" v-for="userWorkingHour of approvedWorkingHoursOther.working_hours_members">
						<div class="unfold"></div>
						<span>{{ parseDate(userWorkingHour.date)}}</span>
						<span>{{ userWorkingHour.display_name }}</span>
						<span>{{ formatTime(userWorkingHour.working_hour.start_time) }}</span>
						<span>{{ formatTime(userWorkingHour.working_hour.end_time) }}</span>
						<span>{{ userWorkingHour.working_hour.timeWorked }}</span>
						<div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="card">
			<div class="title">URENREGISTRATIE</div>
			<div class="unapproved table">
				<div class="headers row">
					<div class="unfold-placeholder"></div>
					<span>Datum</span>
					<span>Medewerker</span>
					<span>Begintijd</span>
					<span>Eindtijd</span>
					<span>Gewerkt</span>
					<div></div>
				</div>
				<div class="row" v-for="teamWorkingHour in unapprovedWorkingHours">
					<div class="inner-row clickable" @click="clearEditingWorkingHours(); unfoldedUnapprovedWorkingHoursId = unfoldedUnapprovedWorkingHoursId === teamWorkingHour.id + teamWorkingHour.date ? null : teamWorkingHour.id + teamWorkingHour.date">
						<button class="unfold button">
							<ChevronUpIcon v-if="unfoldedUnapprovedWorkingHoursId === teamWorkingHour.id + teamWorkingHour.date" size="36"/>
							<ChevronDownIcon v-else size="36"/>
						</button>
						<span>{{ parseDate(teamWorkingHour.date) }}</span>
						<span>{{ teamWorkingHour.display_name }}</span>
						<span></span>
						<span></span>
						<span>{{ teamWorkingHour.totalTimeWorked }}</span>
						<div></div>
					</div>
					<div class="inner-row" v-if="unfoldedUnapprovedWorkingHoursId === teamWorkingHour.id + teamWorkingHour.date" v-for="userWorkingHour of teamWorkingHour.working_hours_members">
						<div class="unfold"></div>
						<span>{{ parseDate(userWorkingHour.date)}}</span>
						<span>{{ userWorkingHour.display_name }}</span>
						<span>
							<input v-if="workingHoursEditingUserId === userWorkingHour.id" v-model="workingHoursEditingStartTime">
							<span v-else>
								{{ formatTime(userWorkingHour.working_hour.start_time) }}
							</span>
						</span>
						<span>
							<input v-if="workingHoursEditingUserId === userWorkingHour.id" v-model="workingHoursEditingEndTime">
							<span v-else>
								{{ formatTime(userWorkingHour.working_hour.end_time) }}
							</span>
						</span>
						<span>{{ userWorkingHour.working_hour.timeWorked }}</span>
						<div>
							<button class="cross button" @click="toggleEditWorkingHours(userWorkingHour)">
								<XIcon></XIcon>
							</button>
							<button class="check button" @click="workingHoursEditingUserId === userWorkingHour.id ? alterWorkingHours(userWorkingHour) : approveWorkingHours(userWorkingHour)">
								<CheckIcon></CheckIcon>
							</button>
						</div>
					</div>
					<div class="inner-row" v-if="unfoldedUnapprovedWorkingHoursId === teamWorkingHour.id + teamWorkingHour.date" v-for="userWorkingHour of teamWorkingHour.working_hours_members_approved">
						<div class="unfold"></div>
						<span>{{ parseDate(userWorkingHour.date)}}</span>
						<span>{{ userWorkingHour.display_name }}</span>
						<span>
								{{ formatTime(userWorkingHour.working_hour.start_time) }}
						</span>
						<span>
								{{ formatTime(userWorkingHour.working_hour.end_time) }}
						</span>
						<span>{{ userWorkingHour.working_hour.timeWorked }}</span>
						<div>

						</div>
					</div>
				</div>
				<div class="row" v-if="unapprovedWorkingHoursOther != null">
					<div class="inner-row clickable" @click="clearEditingWorkingHours(); unfoldedUnapprovedWorkingHoursId = unfoldedUnapprovedWorkingHoursId === unapprovedWorkingHoursOther.id + unapprovedWorkingHoursOther.date ? null : unapprovedWorkingHoursOther.id + unapprovedWorkingHoursOther.date">
						<button class="unfold button">
							<ChevronUpIcon v-if="unfoldedUnapprovedWorkingHoursId === unapprovedWorkingHoursOther.id + unapprovedWorkingHoursOther.date" size="36"/>
							<ChevronDownIcon v-else size="36"/>
						</button>
						<span>{{ parseDate(unapprovedWorkingHoursOther.date) }}</span>
						<span>{{ unapprovedWorkingHoursOther.display_name }}</span>
						<span></span>
						<span></span>
						<span>{{ unapprovedWorkingHoursOther.totalTimeWorked }}</span>
						<div></div>
					</div>
					<div class="inner-row" v-if="unfoldedUnapprovedWorkingHoursId === unapprovedWorkingHoursOther.id + unapprovedWorkingHoursOther.date" v-for="userWorkingHour of unapprovedWorkingHoursOther.working_hours_members">
						<div class="unfold"></div>
						<span>{{ parseDate(userWorkingHour.date)}}</span>
						<span>{{ userWorkingHour.display_name }}</span>
						<span>
							<input v-if="workingHoursEditingUserId === userWorkingHour.id" v-model="workingHoursEditingStartTime">
							<span v-else>
								{{ formatTime(userWorkingHour.working_hour.start_time) }}
							</span>
						</span>
						<span>
							<input v-if="workingHoursEditingUserId === userWorkingHour.id" v-model="workingHoursEditingEndTime">
							<span v-else>
								{{ formatTime(userWorkingHour.working_hour.end_time) }}
							</span>
						</span>
						<span>{{ userWorkingHour.working_hour.timeWorked }}</span>
						<div>
							<button class="cross button" @click="toggleEditWorkingHours(userWorkingHour)">
								<XIcon></XIcon>
							</button>
							<button class="check button" @click="workingHoursEditingUserId === userWorkingHour.id ? alterWorkingHours(userWorkingHour) : approveWorkingHours(userWorkingHour)">
								<CheckIcon></CheckIcon>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import moment from "moment";
import CheckIcon from "vue-feather-icons/icons/CheckIcon";
import ChevronDownIcon from "vue-feather-icons/icons/ChevronDownIcon";
import ChevronUpIcon from "vue-feather-icons/icons/ChevronUpIcon";
import {mapActions, mapState} from "vuex";
import {client} from "../../store";
import {parseDate} from "../../utils";
import XIcon from "vue-feather-icons/icons/XIcon";

export default {
	name: "Leave",
	components: {
		ChevronDownIcon,
		ChevronUpIcon,
		XIcon, CheckIcon},

	data() {
		return {
			unapprovedWorkingHours: [],
			unfoldedUnapprovedWorkingHoursId: null,
			approvedWorkingHours: [],
			unapprovedWorkingHoursOther: null,
			approvedWorkingHoursOther: null,
			unfoldedApprovedWorkingHoursId: null,
			showApprovedWorkingHours: false,
			weeks: [],
			selectedWeek: null,
			monthNames: [
				'Januari', 'Februari', 'Maart', 'April', 'Mei',
				'Juni', 'Juli', 'Augustus', 'September',
				'Oktober', 'November', 'December',
			],
			months: [],
			selectedMonth: null,
			workingHoursEditingUserId: null,
			workingHoursEditingStartTime: null,
			workingHoursEditingEndTime: null,
			branches: [
				"Burgum", "Enschede", "Hoofddorp", "Klundert", "Nijkerk", "Overig"
			],
			selectedBranch: null,
			vans: [],
			selectedVan: null,
			users: [],
			selectedUser: null
		}
	},
	computed: {
		...mapState({
			isLoading: "loading"
		})
	},

	methods: {
		...mapActions({
			setLoading: "map/setLoading",
			setIdle: "map/setIdle",
		}),
		parseDate,

		toggleEditWorkingHours(workingHours) {
			if(this.workingHoursEditingUserId === workingHours.id) {
				this.clearEditingWorkingHours();
				return;
			}

			this.workingHoursEditingUserId = workingHours.id;
			this.workingHoursEditingStartTime = this.formatTime(workingHours.start_time);
			this.workingHoursEditingEndTime = this.formatTime(workingHours.end_time);
		},

		clearEditingWorkingHours() {
			this.workingHoursEditingUserId = null;
			this.workingHoursEditingStartTime = null;
			this.workingHoursEditingEndTime = null;
		},

		refreshData() {
			this.setLoading();
			this.workingHoursEditingUserId = null;
			this.getUnapprovedWorkingHoursTeams();
			this.getApprovedWorkingHoursTeams();
			this.getUnapprovedWorkingHoursWithoutTeam();
			this.getApprovedWorkingHoursWithoutTeam();

		},
		alterWorkingHours(workingHoursUser) {
			this.setLoading()
			if(!this.validateTime(this.workingHoursEditingStartTime) || !this.validateTime(this.workingHoursEditingEndTime)) {
				this.$notify({
					group: "app",
					title: "Urenregistratie aanpassen mislukt",
					type: "error",
					text: "De begintijd of eindtijd is niet in het juiste formaat"
				});
				return;
			}
			client.query(`
				mutation($id: ID, $userId: ID, $startTime: String, $endTime: String, $date: String) {
					alterWorkingHour(id: $id, userId: $userId, startTime: $startTime, endTime: $endTime, date: $date)
				}`, {
					id: workingHoursUser.working_hour == null || workingHoursUser.working_hour.id == null ? null : workingHoursUser.working_hour.id,
					userId: workingHoursUser.id,
					startTime: this.parseTime(this.workingHoursEditingStartTime),
					endTime: this.parseTime(this.workingHoursEditingEndTime),
					date: workingHoursUser.date
				}
			).then(result => {
				if(result.alterWorkingHour === false) {
					this.$notify({
						group: "app",
						title: "Urenregistratie aanpassen mislukt",
						type: "error",
						text: "Er is een fout opgetreden bij het aanpassen van de urenregistratie"
					});
					return;
				}
				this.$notify({
					group: "app",
					title: "Urenregistratie aangepast",
					type: "success",
					text: "De urenregistratie is aangepast"
				});
				this.refreshData();
			}).catch((error) => {
				console.error(error);
				this.$notify({
					group: "app",
					title: "Urenregistratie aanpassen mislukt",
					type: "error",
					text: "Er is een fout opgetreden bij het aanpassen van de urenregistratie"
				});
			});

		},
		approveWorkingHours(workingHourUser) {
			client.query(`
				mutation($id: ID, $userId: ID, $date: String) {
					approveWorkingHour(id: $id, userId: $userId, date: $date)
				}`, {
					id: workingHourUser.working_hour == null || workingHourUser.working_hour.id == null ? null : workingHourUser.working_hour.id,
					userId: workingHourUser.id,
					date: workingHourUser.date
				}
			).then(result => {
				if(result.approveWorkingHour === false) {
					this.$notify({
						group: "app",
						title: "Urenregistratie goedkeuren mislukt",
						type: "error",
						text: "Er is een fout opgetreden bij het goedkeuren van de urenregistratie"
					});
					return;
				}
				this.$notify({
					group: "app",
					title: "Urenregistratie goedgekeurd",
					type: "success",
					text: "De urenregistratie is goedgekeurd"
				});
				this.refreshData();
			}).catch((error) => {
				console.error(error);
				this.$notify({
					group: "app",
					title: "Urenregistratie goedkeuren mislukt",
					type: "error",
					text: "Er is een fout opgetreden bij het goedkeuren van de urenregistratie"
				});
			});
		},

		getUnapprovedWorkingHoursTeams() {
			if(this.selectedVan === "other") {
				this.unapprovedWorkingHours = [];
				return;
			}
			const {from, to} = this.getSelectedFromTo();
			client.query(`
				query($privilege: String, $from: String, $to: String, $branch: String, $teamId: Int, $memberId: Int) {
					getTeamsByDayForPrivilege(privilege: $privilege, from: $from, to: $to, branch: $branch, teamId: $teamId, memberId: $memberId) {
						id
						display_name
						date
						working_hours_members(from: $from, to: $to, approved: false) {
							id
							display_name
							date
							working_hour(approved: false) {
								id
								start_time
								end_time
							}
						}
						working_hours_members_approved: working_hours_members(from: $from, to: $to, approved: true) {
							id
							display_name
							date
							working_hour(approved: true) {
								id
								start_time
								end_time
							}
						}

					}
				}`, {
					privilege: "doorgeven/uren",
					from: from,
					to: to,
					branch: this.selectedBranch === "all" ? null : this.selectedBranch,
					teamId: this.selectedVan === "all" ? null : this.selectedVan,
					memberId: this.selectedUser === "all" ? null : this.selectedUser
				}
			).then(result => {
				this.unapprovedWorkingHours = this.parseWorkingHours(result.getTeamsByDayForPrivilege);
				this.setIdle();
			}).catch((error) => {
				console.error(error);
				this.$notify({
					group: "app",
					title: "Niet goedgekeurde urenregistratie ophalen mislukt",
					type: "error",
					text: "Er is een fout opgetreden bij het ophalen van de informatie"
				});
			});
		},

		getApprovedWorkingHoursTeams() {
			if(this.selectedVan === "other") {
				this.unapprovedWorkingHours = [];
				return;
			}
			// week 26 has data
			const {from, to} = this.getSelectedFromTo();
			client.query(`
				query($privilege: String, $from: String, $to: String, $branch: String, $teamId: Int, $memberId: Int) {
					getTeamsByDayForPrivilege(privilege: $privilege, from: $from, to: $to, branch: $branch, teamId: $teamId, memberId: $memberId) {
						id
						display_name
						date
						working_hours_members(from: $from, to: $to, approved: true) {
							id
							display_name
							date
							working_hour(approved: true) {
								id
								start_time
								end_time
							}
						}
					}
				}`, {
					privilege: "doorgeven/uren",
					from: from,
					to: to,
					branch: this.selectedBranch === "all" ? null : this.selectedBranch,
					teamId: this.selectedVan === "all" ? null : this.selectedVan,
					memberId: this.selectedUser === "all" ? null : this.selectedUser
				}
			).then(result => {
				this.approvedWorkingHours = this.parseWorkingHours(result.getTeamsByDayForPrivilege);
			}).catch((error) => {
				console.error(error);
				this.$notify({
					group: "app",
					title: "Goedgekeurde urenregistratie ophalen mislukt",
					type: "error",
					text: "Er is een fout opgetreden bij het ophalen van de informatie"
				});
			});
		},
		getUnapprovedWorkingHoursWithoutTeam() {
			if ((this.selectedVan != null || this.selectedUser != null) && this.selectedVan !== "all" && this.selectedUser !== "all" && this.selectedVan !== "other") {
				this.unapprovedWorkingHoursOther = null;
				return;
			}
			const {from, to} = this.getSelectedFromTo();
			client.query(`
				query($privilege: String, $from: String, $to: String, $branch: String) {
					getUsersWithoutTeamByDayForPrivilege(privilege: $privilege, from: $from, to: $to, branch: $branch) {
						id
						display_name
						date
						working_hour(approved: false) {
							id
							start_time
							end_time
						}
					}
				}`, {
					privilege: "doorgeven/uren",
					from: from,
					to: to,
					branch: this.selectedBranch === "all" ? null : this.selectedBranch
				}
			).then(result => {
				this.unapprovedWorkingHoursOther = this.parseWorkingHoursOthers(result.getUsersWithoutTeamByDayForPrivilege);
				this.setIdle();
			}).catch((error) => {
				console.error(error);
				this.$notify({
					group: "app",
					title: "Goedgekeurde urenregistratie ophalen mislukt",
					type: "error",
					text: "Er is een fout opgetreden bij het ophalen van de informatie"
				});
			});
		},
		getApprovedWorkingHoursWithoutTeam() {
			if ((this.selectedVan != null || this.selectedUser != null) && this.selectedVan !== "all" && this.selectedUser !== "all" && this.selectedVan !== "other") {
				this.unapprovedWorkingHoursOther = null;
				return;
			}
			const {from, to} = this.getSelectedFromTo();
			client.query(`
				query($privilege: String, $from: String, $to: String, $branch: String) {
					getUsersWithoutTeamByDayForPrivilege(privilege: $privilege, from: $from, to: $to, branch: $branch) {
						id
						display_name
						date
						working_hour(approved: true) {
							id
							start_time
							end_time
						}
					}
				}`, {
					privilege: "doorgeven/uren",
					from: from,
					to: to,
					branch: this.selectedBranch === "all" ? null : this.selectedBranch
				}
			).then(result => {
				this.approvedWorkingHoursOther = this.parseWorkingHoursOthers(result.getUsersWithoutTeamByDayForPrivilege);
				this.setIdle();
			}).catch((error) => {
				console.error(error);
				this.$notify({
					group: "app",
					title: "Goedgekeurde urenregistratie ophalen mislukt",
					type: "error",
					text: "Er is een fout opgetreden bij het ophalen van de informatie"
				});
			});
		},
		getSelectedFromTo() {
			if(this.selectedWeek != null) {
				const from = moment().set('week', this.selectedWeek).startOf('isoWeek').format('YYYY-MM-DD')
				const to = moment().set('week', this.selectedWeek).endOf('isoWeek').format('YYYY-MM-DD')
				return {from: from, to: to};
			}
			if(this.selectedMonth != null) {
				const month = parseInt(this.selectedMonth.split('-')[0], 10);
				const year = parseInt(this.selectedMonth.split('-')[1], 10);
				const from = moment().set('month', month - 1).set('year', year).startOf('month').format('YYYY-MM-DD')
				const to = moment().set('month', month - 1).set('year', year).endOf('month').format('YYYY-MM-DD')
				return {from: from, to: to};
			}
			return {from: null, to: null};
		},

		parseWorkingHours(teams) {
			teams = teams.filter(
				team => team.working_hours_members.length > 0
			);
			teams.map(team => {
				let totalTimeWorked = 0;
				team.working_hours_members.map(member => {
					member.working_hour = this.addTimeWorked(member.working_hour);
					totalTimeWorked += member.working_hour.timeWorkedMinutes;
					return member;
				});
				if(team.hasOwnProperty("working_hours_members_approved")) {
					team.working_hours_members_approved.map(member => {
						member.working_hour = this.addTimeWorked(member.working_hour);
						totalTimeWorked += member.working_hour.timeWorkedMinutes;
						return member;
					});
				}
				// add leading zero to minutes
				team.totalTimeWorked = Math.floor(totalTimeWorked / 60) + ':' + this.zeroPad(totalTimeWorked % 60);
			});
			return teams;
		},
		parseWorkingHoursOthers(users) {
			if (users == null || users.length === 0) {
				return null;
			}
			users = users.filter(user => user.working_hour != null);
			if (users.length === 0) {
				return null;
			}
			let totalTimeWorked = 0;
			users.map(user => {
				user.working_hour = this.addTimeWorked(user.working_hour);
				totalTimeWorked += user.working_hour.timeWorkedMinutes;
				return user;
			});
			return {
				id: -1,
				display_name: "Overig",
				working_hours_members: users,
				totalTimeWorked: Math.floor(totalTimeWorked / 60) + ':' + this.zeroPad(totalTimeWorked % 60),
				date: users[0].date
			}


		},
		zeroPad(number) {
			return number.toString().padStart(2, '0');
		},

		addTimeWorked(workingHour) {
			if(workingHour == null || workingHour.start_time == null) {
				return {
					timeWorked: '-',
					timeWorkedMinutes: 0
				};
			}
			const startTime = workingHour.start_time.split(':');
			const endTime = workingHour.end_time != null ? workingHour.end_time.split(':') : workingHour.start_time.split(':');
			const startMinutes = parseInt(startTime[0], 10) * 60 + parseInt(startTime[1], 10);
			const endMinutes = parseInt(endTime[0], 10) * 60 + parseInt(endTime[1], 10);
			let timeWorked = endMinutes - startMinutes;
			if(endTime[0] > 13 && timeWorked > 30) {
				timeWorked -= 30;
			}
			workingHour.timeWorked = Math.floor(timeWorked / 60) + ':' + this.zeroPad(timeWorked % 60);
			workingHour.timeWorkedMinutes = timeWorked;
			return workingHour;
		},
		formatTime(time) {
			if(time == null) {
				return '-';
			}
			return time.substring(0, time.length - 3);
		},
		setInitialCurrentWeekFilter() {
			// add weeks from now going back to a year
			for(let i = 0; i < 52; i++) {
				const tempMoment = moment().subtract(i, 'weeks');
				const weekNumber = tempMoment.week();
					this.weeks.push(weekNumber);
			}
			this.selectedWeek = this.weeks[0];
		},
		setInitialMonthFilter() {
			const date = new Date();
			for (let i = 0; i < 12; i++) {
				this.months.push({label: this.monthNames[date.getMonth()], value: date.getMonth() + 1 + '-' + date.getFullYear()});
				date.setMonth(date.getMonth() - 1);
			}
		},
		validateTime(time) {
			if(time == null || time === '-' || time === '') {
				return true;
			}
			// test if time is format HH:MM
			const regex = new RegExp('^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$');
			return regex.test(time);
		},
		parseTime(time) {
			if(!this.validateTime(time) || time === '-') {
				return null;
			}
			return time;
		},
		refreshUserFilters() {
			this.selectedVan = null;
			this.selectedUser = null;
			this.getVans();
			this.getUsers();
		},
		getVans() {
			client.query(`
				query($roles: [String], $branch: String, $orderBy: String) {
					users(roles: $roles, branch: $branch, orderBy: $orderBy) {
						id
						display_name
					}
      			}
		`, {
				roles: ["THERMO_FOAM", "GROUND", "FLOOR", "SUPPORT", "FTX1", "IMPREGNEREN"],
				branch: this.selectedBranch !== "all" ? this.selectedBranch : null,
				orderBy: 'display_name'
			}).then(result => {
				this.vans = result.users;
			}).catch(error => {
				console.log(error);
			});
		},
		getUsers() {
			client.query(`
				query($role: String, $branch: String, $orderBy: String, $privilege: String) {
					users(role: $role, branch: $branch, orderBy: $orderBy, privilege: $privilege) {
						id
						display_name
					}
      			}
		`, {
				role: "EXECUTOR",
				branch: this.selectedBranch !== "all" ? this.selectedBranch : null,
				orderBy: 'display_name',
				privilege: "doorgeven/uren"
			}).then(result => {
				this.users = result.users;
			}).catch(error => {
				console.log(error);
			});
		}
	},

	beforeMount() {
		this.refreshUserFilters();
		this.setInitialCurrentWeekFilter();
		this.setInitialMonthFilter();
		this.refreshData();
	}
}
</script>

<style lang="scss" scoped>
.LeaveDashboardPage {
	height: calc(100% - 44px);
	padding: 24px;
	overflow-y: auto;

	.filters-container {
		display: flex;
		flex-direction: row;
		gap: 16px;
		margin-bottom: 16px;

		select {
			width: 100%;
			border: 2px solid #c5ced6;
			background-color: #fff;
			padding: 6px;
			font-size: 1rem;
			border-radius: 4px;
		}
	}

	.requests.card {
		margin-bottom: 24px;
	}

	.card {
		background-color: #ffffff;
		padding: 24px;
		border: 3px solid #e0e0e0;

		.title {
			color: #1aae9f;
			font-weight: 800;
			font-size: 1.5em;
			margin-bottom: 24px;
			display: flex;
			align-items: center;

			.unfold {
				width: 48px;
				height: 48px;
				border: none;
				background-color: #FFFFFF;
				color: #788896;
			}
		}

		.table {
			display: flex;
			flex-direction: column;
			gap: 8px;

			.headers {
				font-weight: 800;
				margin-bottom: 8px;
				display: flex;
				flex-direction: row;

				span {
					width: calc((100% - 88px) / 5);
					display: inline-flex;
					align-items: center;
				}

				.unfold-placeholder {
					width: 48px;
					height: 48px;
				}
				div {
					width: 88px;
				}
			}

			.row {
				border-bottom: 1px solid #788896;
				.inner-row {
					display: flex;
					flex-direction: row;
					align-items: center;

					span {
						width: calc((100% - 88px) / 5);
						display: inline-flex;
						align-items: center;

						input {
							border: 2px solid #c5ced6;
							background-color: #fff;
							padding: 6px;
							font-size: 1rem;
							border-radius: 4px;
						}
					}

					.unfold {
						width: 48px;
						height: 48px;
						border: none;
						background-color: #FFFFFF;
						color: #788896;
					}

					div {
						width: 88px;
						display: flex;
						flex-direction: row;
						gap: 8px;

						.button {
							display: block;
							padding: 8px 8px 4px 8px;
							border-radius: 4px;
							border: none;
							color: #ffffff;

							&.cross {
								background-color: #d3455b;
							}

							&.check {
								background-color: #1aae9f;
							}
						}
					}
				}
			}
		}
	}
}
</style>
